define('collections/calendar/nutrition/entry-tags',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api',
    // models
    'models/calendar/nutrition/entry-tag'
], function(
    // libs
    _, Backbone, U,
    // services
    API,
    // model
    MEntryTag
) {

    var CEntryTags = Backbone.Collection.extend({
        model: MEntryTag,
        url: API.url("nutrition/tags"),

        parse: function(resp) {
            return _.map(resp, function(text, key) {
                return { tag: key, text: text };
            });
        },
    });

    return CEntryTags;
});

